/**
 * Constant map palette (A6 slice 9). The analytics basemap stays LIGHT (spec §5.6),
 * so these ramps are NOT mode-aware and NOT Chakra tokens — maplibre paint
 * expressions take literal hex, not CSS vars. Values are byte-identical to the
 * pre-slice-9 choropleth.ts. This file is excluded from the raw-hex ratchet.
 * Off-map charts must use the mode-aware viz tokens instead (theme/tokens.ts).
 */
export const DIVERGING_RAMP = ['#B2182B', '#F7F7F7', '#2166AC'] as const // R → neutral → D
export const SEQUENTIAL_RAMP = ['#EFF6FF', '#1E3A8A'] as const
export const SUPPRESSED_FILL = '#CBD5E0'

/**
 * Bivariate lean × turnout palette ([turnoutRow][leanCol]; row 0 = low turnout,
 * col 0 = R lean). Relocated from bivariate.ts (A6 slice 9 Task 10, F1) — same
 * constant-map-palette family as the ramps above: the analytics basemap stays
 * LIGHT, so this is not mode-aware and not a Chakra token. Byte-identical to
 * the pre-relocation values; bivariate.ts re-exports this same reference.
 */
export const BIVARIATE_PALETTE: string[][] = [
  ['#F1B8B0', '#E5D0E8', '#B9C9F0'], // low turnout
  ['#DE7E71', '#C08FC9', '#7D9BE3'], // mid
  ['#C93F2F', '#93419F', '#3B63C4'], // high
]
